// FieldDesk — design tokens. Соответствуют референсу `Field Service Platform.html`
// и цветам статусов/типов из Telegram Mini App для визуальной консистентности.

export const COLORS = {
  sidebarBg: '#0f172a',
  sidebarAccent: '#60a5fa',
  sidebarMuted: '#64748b',
  sidebarHover: 'rgba(37,99,235,0.25)',
  sidebarBorder: 'rgba(37,99,235,0.35)',
  pageBg: '#f1f5f9',
  surface: '#ffffff',
  text: '#0f172a',
  textMuted: '#64748b',
  textSoft: '#475569',
  primary: '#2563eb',
  primaryDark: '#1d4ed8',
  border: '#e2e8f0',
  danger: '#dc2626',
  warning: '#d97706',
  success: '#16a34a',
  info: '#0891b2',
} as const;

// Маппинг типов визитов → цвет (для карточек, графиков, badge'ей).
// Тип DUTY удалён в миграции 20260502120000_remove_visit_type_duty.
export const TYPE_COLOR: Record<string, string> = {
  INSTALLATION: '#2563eb',
  TRAINING: '#059669',
  PAID_VISIT: '#d97706',
};

export const TYPE_LABEL: Record<string, string> = {
  INSTALLATION: 'Установка',
  TRAINING: 'Обучение',
  PAID_VISIT: 'Платный выезд',
};

// Статусы → bg+текст, как в референсе.
export const STATUS_SCHEMA: Record<string, { bg: string; color: string; label: string }> = {
  PLANNED: { bg: '#eff6ff', color: '#2563eb', label: 'Запланирован' },
  EN_ROUTE: { bg: '#fef3c7', color: '#d97706', label: 'В пути' },
  ON_SITE: { bg: '#ecfdf5', color: '#059669', label: 'На месте' },
  COMPLETED: { bg: '#f0fdf4', color: '#16a34a', label: 'Выполнен' },
  CANCELLED: { bg: '#fef2f2', color: '#dc2626', label: 'Отменён' },
};
